import { CAROUSEL_ANALYTICS_MODULE_NAME, CAROUSEL_ANALYTICS_MODULE_POSITION, CAROUSEL_ANALYTICS_MODULE_TYPE } from '@/app/components/sections/HeroCarousel/constants'
import { slugify } from '@/app/lib/analytics/dataLayer'
import type { ViewPromotionParams } from '@/app/lib/analytics/types'

import type { HeroGaleriaMosaicTile } from './HeroGaleria.types'

/**
 * `view_promotion`/`select_promotion` de una celda del hero en mosaico/banner.
 *
 * ⚠️ PENDIENTE DE CONFIRMAR CON ANALÍTICA. La guía no tiene ficha para este
 * componente; se aplica por criterio transversal `Carousel.csv` (módulo
 * transversal, `00_Instrucciones.md`), porque `HeroGaleria` ocupa el lugar del
 * `HeroCarousel` en las páginas donde éste no está habilitado:
 * - `module_name`/`module_type`/`module_position`: los mismos del `HeroCarousel`
 *   (`carousel` / `hero_carousel` / `1`), por ocupar el mismo hueco de página.
 * - `creative_name`: `hero_full` (ejemplo del enum de `analytic-e-commerce.md`).
 * - `creative_slot`: `cover` la primera celda y `slide_N` las siguientes
 *   (`analytic-e-commerce.md`).
 * - `promotion_id`: id de la celda; `promotion_name`: alt/título normalizado.
 * Las celdas no enlazan a ningún destino: el "click" es sobre la propia pieza.
 */
export const HERO_GALERIA_CREATIVE_NAME = 'hero_full'

export function toHeroGaleriaPromotionParams(tile: HeroGaleriaMosaicTile, index: number): ViewPromotionParams {
  const label = tile.kind === 'video' ? tile.title : tile.alt
  return {
    module_name: CAROUSEL_ANALYTICS_MODULE_NAME,
    module_type: CAROUSEL_ANALYTICS_MODULE_TYPE,
    module_position: CAROUSEL_ANALYTICS_MODULE_POSITION,
    promotion_id: tile.id,
    promotion_name: slugify(label || tile.id),
    creative_name: HERO_GALERIA_CREATIVE_NAME,
    creative_slot: index === 0 ? 'cover' : `slide_${index + 1}`,
    index: index + 1,
  }
}
